import { render, staticRenderFns } from "./CandidatesTryToReserve.vue?vue&type=template&id=978df1c6&lang=pug"
import script from "./CandidatesTryToReserve.vue?vue&type=script&lang=js"
export * from "./CandidatesTryToReserve.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports